var _script, _g, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaRetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    async: "false",
    type: "text/javascript",
    src: "moz-extension://33d4f970-0f6d-4e56-ae9a-a8614e04c84f/in-page.js"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15400_118843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43377 4.19318L1.97748 3.56818L1.74658 3H5.63333L6.43377 4.19318Z",
    fill: "#4023F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.26 10.7415L12.8295 7.61648L5.04834 4.875L15 6.38068L12.26 10.7415Z",
    fill: "#4023F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6983 11.0398H1.68506L3.99402 4.96021L12.2447 7.80822L11.6983 11.0398Z",
    fill: "#4023F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13L1.42331 11.892H10.2435L1 13Z",
    fill: "#4023F2"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    path {\n    fill: #4023F2;\n    }\n    @media (prefers-color-scheme: dark) {\n    path {\n    fill: white;\n    }\n    }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaRetailIcon);
export default __webpack_public_path__ + "static/media/media_retail-icon.cf20c03c296b51b68027f2a007e8f707.svg";
export { ForwardRef as ReactComponent };